export enum EIremboFormlyFormStateKeys {
  FETCHED_DATA = 'FETCHED_DATA',
  FETCHED_OPTIONS_DATA = 'FETCHED_OPTIONS_DATA',
  APPLICATION_STATE = 'APPLICATION_STATE',
  RFA_FLAGGED_FIELDS = 'RFA_FLAGGED_FIELDS',
  ALLOW_EDITING_ALL_FIELDS = 'ALLOW_EDITING_ALL_FIELDS',
  APPLICANT_BUSINESS_NAME = 'APPLICANT_BUSINESS_NAME',
  APPLICANT_BUSINESS_ID = 'APPLICANT_BUSINESS_ID',
  APPLICANT_TYPE = 'APPLICANT_TYPE',
  LOCALE = 'LOCALE',
}
